/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecretResult } from '../../models/secret-result';
import { UpdateSecretRequest } from '../../models/update-secret-request';

export interface ApiSecretsIdPut$Params {
  id: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: UpdateSecretRequest
}

export function apiSecretsIdPut(http: HttpClient, rootUrl: string, params: ApiSecretsIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResult>> {
  const rb = new RequestBuilder(rootUrl, apiSecretsIdPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecretResult>;
    })
  );
}

apiSecretsIdPut.PATH = '/api/Secrets/{id}';
